import React, { Component } from 'react';
import { Spin, Icon } from 'antd';

const antIcon = <Icon className='epar__spinner' type="loading" style={{ fontSize: 48 }} spin />;

export default class ConnectLoading extends Component {
  render(){
    return (<div className='epar__spinner__container'> <Spin size="large" indicator={antIcon} /> </div>);
  }
}